/* eslint-disable import/prefer-default-export */

// Company feature names the Succeedo frontend checks against
// `company.features`. Keep in step with the server-side flag names.
export const GEORGE_CONVERSATION_FEATURE = 'succeedo_george_conversation';
export const GEORGE_UNDERSTANDING_FEATURE = 'succeedo_george_understanding';
